import { ca } from '@cian/analytics';

import { type IDeveloperRatingsForCardSchema } from 'shared/repositories/special-promos/entities/developer_ratings_for_card/DeveloperRatingsForCardSchema';

/**
 * @description Событие: блок рейтингов попал в зону видимости.
 */
export function trackShowRatingsBlock(ratings: IDeveloperRatingsForCardSchema['ratings']): void {
  ca('eventSite', {
    action: 'show_rating',
    category: 'Promo',
    name: 'oldevent',
    products: ratings.map((rating, index) => ({
      id: rating.valueLabel,
      offerType: 'label',
      position: index,
    })),
  });
}
